/**
 * @fileoverview Defines the types and interfaces for the messaging system.
 * This includes message types, database schemas, and UI representations.
 */
/** Constant representing a text message type */
export const MessageType_Text = 'text';
/** Constant representing an image message type */
export const MessageType_Image = 'image';
/** Constant representing a video message type */
export const MessageType_Video = 'video';
//# sourceMappingURL=types.js.map